import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const CookieBanner = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAcceptAll = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleRejectAll = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setIsVisible(false);
  };

  const handleCustomize = () => {
    // Vous pouvez ajouter une modale de personnalisation ici
    localStorage.setItem('cookieConsent', 'customized');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-6 bg-white shadow-2xl border-t-4 border-[#E31B23]">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-start lg:items-center gap-6">
          {/* Icon */}
          <div className="flex-shrink-0">
            <div className="w-16 h-16 bg-[#E31B23]/10 rounded-full flex items-center justify-center">
              <i className="ri-shield-check-line text-[#E31B23] text-3xl w-8 h-8 flex items-center justify-center"></i>
            </div>
          </div>

          {/* Content */}
          <div className="flex-1">
            <h3 className="text-2xl font-bold text-[#1A1A1A] mb-3">
              Nous respectons votre vie privée
            </h3>
            <p className="text-gray-600 leading-relaxed">
              Nous utilisons des cookies et des technologies similaires pour personnaliser le contenu, adapter et mesurer les publicités, et offrir une meilleure expérience. En cliquant sur Accepter tout, vous consentez à cette utilisation des cookies et des données comme décrit dans notre{' '}
              <Link 
                to="/legal/politique-confidentialite" 
                className="text-[#E31B23] hover:underline font-medium cursor-pointer"
              >
                Politique de confidentialité
              </Link>
              .
            </p>
          </div>

          {/* Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 w-full lg:w-auto">
            <button
              onClick={handleAcceptAll}
              className="px-8 py-3 bg-[#E31B23] text-white rounded-lg font-semibold hover:bg-[#C41820] transition-all duration-300 shadow-lg hover:shadow-xl cursor-pointer whitespace-nowrap"
            >
              Accepter tout
            </button>
            <button
              onClick={handleRejectAll}
              className="px-8 py-3 bg-gray-200 text-gray-700 rounded-lg font-semibold hover:bg-gray-300 transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Tout refuser
            </button>
            <button
              onClick={handleCustomize}
              className="px-8 py-3 bg-white border-2 border-gray-300 text-gray-700 rounded-lg font-semibold hover:border-[#E31B23] hover:text-[#E31B23] transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Personnaliser
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
